<template>

  <b-modal
      id="graph-modal"
      modal-class='form form-export'
      modal-footer="hide"
      scrollable
      centered
      :size="'lg'"
      :title="(this.getGraphCriteria.userName ? this.getGraphCriteria.userName + ' - ' : '') + this.title"
  >

    <b-card class="card-big p-0">
      <div class="text-right">
        <b-button-group class="mb-3">
          <b-button @click="evolutionDate" data-name="month" class="dateChoose">1 mois</b-button>
          <b-button @click="evolutionDate" data-name="sixMonth" class="dateChoose active">6 mois</b-button>
          <b-button @click="evolutionDate" data-name="year" class="dateChoose">1 an</b-button>
        </b-button-group>
      </div>
      <b-overlay
          id="overlay-challenge"
          :show="showMe"
          rounded="sm"
          variant="white"
          opacity='0.8'
          blur="2px"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
      >

        <div>
          <cardBig
              key="month"
              :data = graphData
              :dataIndex = this.getGraphCriteria.key
              :codePtf = this.getGraphCriteria.codePtf
              :period = cardToShow
              :isLoad.sync = isLoading
              :isObjective="false"
              :isNegative='false'
              @changePeriod = "changePeriod"
              ref="cardBig"
              class="mt-4"
          />
        </div>
      </b-overlay>
      <div>
        <div class="d-flex align-items-center"><div class="legend-line blue"></div><p class="m-0">Période N</p></div>
        <div class="d-flex align-items-center"><div class="legend-line grey"></div><p class="m-0">Période N-1</p></div>
      </div>
    </b-card>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import cardBig from "@/components/module/card/CardBig.vue";
import moment from "moment";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";
import ApiService from "@/services/ApiService";
//import ApiService from "@/services/ApiService";

export default {
  name: "GraphModal",
  components: {
    cardBig
  },
  data () {
    return {
      showMe: false,
      isLoading: false,
      id: null,
      title: 'Graphique',
      user: null,
      cardToShow:'sixMonth',
      graphData: null,
      endDate:null,
      selectedDate: null,
    }
  },

  computed: {
    ...mapGetters([
      'getGeneral',
      'getGraphCriteria',
      'getCurrentCodePtf'
    ]),
  },
  methods:{
    changePeriod(data){
      this.cardToShow = data;
      switch (data) {
        case 'month':
          this.endDate = moment(this.selectedDate).subtract(1, 'month');
          break;
        case 'sixMonth':
          this.endDate = moment(this.selectedDate).subtract(6, 'month');
          break;
        case 'year':
          this.endDate = moment(this.selectedDate).subtract(1, 'year');
          break;
      }
      this.getData().then(() => {
        this.isLoading = false;
      });
    },
    async getData(){
      let promises = [];
      this.isLoading = true;

      let userId = ApiAuthenticationService.getCurrentUser().id;

      if(this.user?.id != null) {
        userId = this.user.id;
      }

      promises.push(ApiService.getParcourirApi().getPersonalCriteria(this.getGraphCriteria.userId ?? userId, this.getGraphCriteria.key, this.endDate.format('YYYY-MM-DD'), moment(this.selectedDate).add(1, 'day').format('YYYY-MM-DD')).then((data) => {
        this.graphData = data.data;
      }));

      await Promise.all(promises);
    },
    evolutionDate($e){
      let targets = document.querySelectorAll('.dateChoose');
      targets.forEach(target => target.classList.remove('active'));
      $e.currentTarget.classList.add("active");

      this.$refs.cardBig.setData($e.currentTarget.getAttribute("data-name"));
      this.cardToShow = $e.currentTarget.getAttribute("data-name");
    }
  },

  watch: {
    getGraphCriteria() {
      if (this.getGraphCriteria === '') {
        return;
      }

      this.title = this.getGraphCriteria.name;

      if (!this.selectedDate) {
        ApiService.getParcourirApi().getDates().then((data) => {
          if (data.data.length > 0) {
            this.selectedDate = data.data[0].date;
            this.endDate = moment(this.selectedDate).subtract(6, 'month');
          }
          this.getData().then(() => {this.isLoading = false;});
        });
      } else {
        this.getData().then(() => {this.isLoading = false;});
      }
    },
  },
}
</script>

